export const initialClients = [
  {
    id: 1,
    siret: "23456789000013",
    name: "EHPAD Les Tilleuls",
    city: "Toulouse",
    sector: "Santé",
    source: "France Travail",
    signal: "5 aides-soignants",
    signalDate: "06/10/2026",
    kind: "ancien client",
    lastOrder: "06/06/2026",
    contact: "Mme Dupont",
    role: "Responsable RH",
    phone: "06 12 34 56 78",
    score: 96,
    status: "reactivation",
    need: null,
    orders: [
      {
        id: "order-t1",
        date: "2026-05-09",
        volume: 5,
        amount: 15000,
        margin: 3000,
      },
      {
        id: "order-t2",
        date: "2026-05-23",
        volume: 5,
        amount: 15000,
        margin: 3000,
      },
      {
        id: "order-t3",
        date: "2026-06-06",
        volume: 5,
        amount: 15000,
        margin: 3000,
      },
    ],
    history: [
      "06/06/2026 — Dernière commande",
      "06/10/2026 — Nouveau signal recrutement",
      "06/10/2026 — Réactivation automatique",
    ],
  },
  {
    id: 2,
    siret: "44556677800021",
    name: "Clinique du Parc",
    city: "Toulouse",
    sector: "Santé",
    source: "France Travail",
    signal: "3 IDE vacation",
    signalDate: "05/10/2026",
    kind: "prospect",
    contact: "Mme Bernard",
    role: "DRH",
    phone: "05 61 00 00 01",
    score: 87,
    status: "prospect",
    need: null,
    history: ["05/10/2026 — Signal recrutement importé"],
  },
  {
    id: 3,
    siret: "88990011200044",
    name: "Logipack",
    city: "Colomiers",
    sector: "Logistique",
    source: "Prospection",
    signal: "Préparateurs de commandes",
    signalDate: "06/10/2026",
    kind: "prospect",
    contact: "M. Lopez",
    role: "Resp. logistique",
    phone: "05 61 00 00 02",
    score: 78,
    status: "prospect",
    need: null,
    history: ["06/10/2026 — Prospect créé"],
  },
  {
    id: 4,
    siret: "55112233400018",
    name: "Résidence Bellevue",
    city: "Colomiers",
    sector: "Santé",
    kind: "client",
    status: "CLIENT ACTIF",
    contact: "Paul Durand",
    role: "Directeur",
    phone: "05 61 00 00 04",
    email: "accueil@bellevue.example",
    lastOrder: "2026-10-01",
    history: ["01/10/2026 — Commande confirmée"],
    orders: [
      {
        id: "order-b1",
        date: "2026-09-03",
        volume: 4,
        amount: 12000,
        margin: 2400,
      },
      {
        id: "order-b2",
        date: "2026-09-17",
        volume: 4,
        amount: 12000,
        margin: 2400,
      },
      {
        id: "order-b3",
        date: "2026-10-01",
        volume: 4,
        amount: 12000,
        margin: 2400,
      },
    ],
    contracts: [
      { id: "contract-b1", label: "Convention commerciale", status: "active" },
    ],
    invoices: [
      {
        id: "invoice-b1",
        label: "Facture septembre",
        amount: 12000,
        status: "réglée",
      },
    ],
  },
  {
    id: 5,
    siret: "99887766500019",
    name: "Centre Hospitalier Nord",
    city: "Lille",
    sector: "Santé",
    kind: "client",
    status: "CLIENT ACTIF",
    contact: "Nadia Robert",
    role: "DRH",
    phone: "03 20 00 00 05",
    agency: "Lille",
    ownerId: "commercial-lille",
    owner: "Commercial Lille",
    lastOrder: "2026-09-01",
    history: ["01/09/2026 — Dernière commande"],
    orders: [
      {
        id: "order-n1",
        date: "2026-08-04",
        volume: 12,
        amount: 24000,
        margin: 4800,
      },
      {
        id: "order-n2",
        date: "2026-08-11",
        volume: 12,
        amount: 24000,
        margin: 4800,
      },
      {
        id: "order-n3",
        date: "2026-08-18",
        volume: 12,
        amount: 24000,
        margin: 4800,
      },
      {
        id: "order-n4",
        date: "2026-09-01",
        volume: 4,
        amount: 8000,
        margin: 1600,
      },
    ],
  },
];
